module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mdl-list"
  }, [_c('li', {
    staticClass: "mdl-list__title"
  }, [_vm._v(_vm._s(_vm.data.fecha || '?'))]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "mdl-list"
  }, _vm._l((_vm.data.auditorias), function(auditoria, index) {
    return _c('li', {
      class: ['audit', 'mdl-list__item', 'mdl-list__item--two-line',
        auditoria.statusId >= 3 ? 'bg-green-light' : ''
      ],
      attrs: {
        "data-index": index
      },
      on: {
        "click": _vm.showReport
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-title"
    }, [_vm._v(_vm._s(auditoria.inmueble))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditoria.empresa))])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      staticClass: "mdl-list__item-sub-title"
    }, [_vm._v(_vm._s(auditoria.incidencias))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v("Incidencias")])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      class: ['mdl-list__item-sub-title',
        auditoria.promedio >= auditoria.aceptable ? 'color-green-light' :
        (auditoria.promedio > auditoria.inaceptable ? 'color-yellow' : 'color-red')
      ]
    }, [_vm._v(_vm._s(auditoria.promedio))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-info"
    }, [_vm._v("Puntos")])]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-secondary-content"
    }, [_c('span', {
      class: ['mdl-list__item-secondary-info',
        auditoria.statusId >= 3 ? 'color-green-light' :
        auditoria.statusId === 2 ? 'color-yellow' : ''
      ]
    }, [_vm._v(_vm._s(auditoria.statusNombre))])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eadeafd4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Auditor/Newsfeed/List.vue
// module id = 257
// module chunks = 0